import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {Button} from 'app/components';
import BookingCard from './bookingCard';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const BookingSuccess = (props) => {
  const {
    className,
    mail,
  } = props;

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { userData } = useSelector((state) => state.app);
  const { bookingData, primaryEventData, selectedCategory, attendeesDetails } = location.state;

  useEffect(() => {
    window.scrollTo(0, 0);

    () => dispatch({ type: 'BOOKING_DATA:CLEAR' })
  }, []);

  if (!location?.state?.bookingData) {
    return <Navigate to="/" />
  }

  const onViewClick = () => {
    navigate('/bookings', {
      replace: true,
    });
  };

  return (
    <div className={`flex mx-auto rounded-xl shadow-xs bg-white booking-success sm:w-full md:w-auto h-fit mt-[150px] ${className}`}>
      <div className='py-9 md:py-10 px-6 md:px-[42px] gap-8 flex flex-col items-center justify-center text-center w-screen md:w-auto'>
        <img src='assets/images/success.svg'
          alt='success'
          className='w-[66px] h-[66px] md:w-auto md:h-auto'/>
        <div className='flex flex-col gap-3'> 
          <div className='heading-24'>Tickets purchased!</div>
          <div className='text-16 px-0 md:px-5'>
            <span className='text-nowrap'> We have sent confirmation to  </span>
            <span className='heading-16'> {userData?.mobile || attendeesDetails?.[0]?.phone_number}</span> and <span className='heading-16'>{userData?.email}</span>
          </div>
        </div>
        
        <BookingCard
            eventName={primaryEventData?.name}
            eventDate={primaryEventData?.start_date}
            venue={primaryEventData?.event_address?.name}
            eventCategory={`${bookingData?.tickets_booked} x ${selectedCategory?.name}`}
            imageUrl={primaryEventData?.image}
            totalAmount={bookingData?.total_price}
        />
        <Button
          type='primary-black'
          onClick={onViewClick}>View Tickets</Button>
      </div>
    </div>
  )
}

export default BookingSuccess;
